import { LaminateInputs } from '../../../types';

type TParams = {
  data: LaminateInputs;
  isRoomArea: boolean;
};

export const getFormData = ({ data, isRoomArea }: TParams): LaminateInputs => {
  const parameters = { ...data };

  Object.keys(parameters).forEach(el => {
    if (parameters[el as keyof LaminateInputs] === '0') {
      delete parameters[el as keyof LaminateInputs];
    }
  });

  const formattedData = { ...parameters };

  if (isRoomArea) {
    formattedData.length = '';
    formattedData.width = '';
  } else {
    formattedData.area = '';
  }

  return formattedData;
};
